import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import {
  ROUTES,
  messages,
  EMPTY_STRING,
  eventBookingParams,
} from "../../../../constants";
import { Images } from "../../../../assets/images";
import { NavigateToPath } from "../../../../system";
import { eventBookingActions } from "../../../../redux/actions";

const EventThankYou = (props) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    props.resetEventBooking();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="thank-you-page d-flex justify-content-center">
      <div className="thank-you-box text-center px-3 px-md-5 py-5">
        <div className="check-icon mb-4">
          <img src={Images.TickMark} alt="" />
        </div>
        <h2 className="thank-you-heading mb-3">thank you!</h2>
        <p className="thank-you-text mb-4 px-1 px-md-5">
          {location?.id === eventBookingParams.DRAFT_EVENT
            ? `we will email you within 24 hours with a potential shutterb(z) for
          your event.`
            : location?.id === eventBookingParams.EDIT_EVENT
            ? `your refund has been processed successfully and should reflect in your account within a few business days.`
            : EMPTY_STRING}
        </p>
        <button
          className="my-event-btn button-common button-fill"
          onClick={() => NavigateToPath(history, ROUTES.MY_EVENTS_TAB)}
        >
          {messages.MY_EVENTS}
        </button>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  resetEventBooking: () => dispatch(eventBookingActions.resetEventBooking()),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(EventThankYou);
